var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgH2 = function SvgH2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 13,
    viewBox: "0 0 21 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007faf",
    fillRule: "evenodd",
    d: "M10.758 11V1.662H7.93v3.304H4.584V1.662H1.756V11h2.828V7.43H7.93V11zm8.96 0V8.536H16.68c2.226-1.47 2.954-2.52 2.954-3.794 0-1.876-1.582-3.22-4.004-3.22-1.302 0-2.87.434-3.948 1.582l1.54 1.876c.714-.602 1.47-.966 2.464-.966.602 0 1.078.28 1.078.728 0 .7-.406 1.05-4.676 4.06V11z"
  })));
};
export default SvgH2;